<template>
  <div
    v-if="visibleSearches.length"
    class="-mx-4 flex gap-2 overflow-x-auto px-4 pt-1"
    style="scrollbar-width: none"
  >
    <RecentSearchCardRedesigned
      v-for="(search, index) in visibleSearches"
      :key="search.timestamp"
      :search="search"
      :index="index"
      @onClick="handleCardClick(search, index)"
      @onDelete="handleDelete(search, index)"
    />
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';

  import type { RecentSearch } from '@/entities/recent-searches';

  import { analyticsEventsLib, type MainPageVariant } from '@/shared/lib';

  import { useRecentSearchesList } from '../model/use-recent-searches-list';
  import RecentSearchCardRedesigned from './RecentSearchCardRedesigned.vue';

  const props = defineProps<{
    variant?: MainPageVariant;
  }>();

  const emit = defineEmits<{
    onSearchClick: [search: RecentSearch, index: number];
  }>();

  const { visibleSearches, removeSearch } = useRecentSearchesList();

  const handleCardClick = (search: RecentSearch, index: number) => {
    analyticsEventsLib.lastSearchesClick(index + 1, props.variant);
    emit('onSearchClick', search, index);
  };

  const handleDelete = (search: RecentSearch, index: number) => {
    removeSearch(search.timestamp);
    analyticsEventsLib.lastSearchesRemove(index + 1, props.variant);
  };

  onMounted(() => {
    if (visibleSearches.value.length) {
      analyticsEventsLib.lastSearchesShow(props.variant);
    }
  });
</script>
